import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { IChatbotGetConvData, IChatbotStartConv } from './chatbot.interface';
import { StoreService } from '../store';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ChatbotService {
	timer: NodeJS.Timeout;
	conversationId: string;
	baseApiUrl: string;
	headers: any;
	conData$: Subject<IChatbotGetConvData> = new Subject<IChatbotGetConvData>();
	conData: IChatbotGetConvData;
	showDialog$: Subject<boolean> = new Subject<boolean>();
	isTyping$: Subject<boolean> = new Subject<boolean>();
	CHATBOT_CONV_ID = 'CHATBOT_CONV_ID';
	errorTimeout$: NodeJS.Timeout;
	ERROR_TIMEOUT = 10000;

	constructor(private configService: ConfigService, private storeService: StoreService) {}

	initService() {
		this.baseApiUrl = this.configService.getConfig().chatbotApi + 'conversations';
		this.conversationId = sessionStorage.getItem(this.CHATBOT_CONV_ID);
		this.conData = {
			activities: [],
			watermark: '',
		};
	}

	async createConversationsPostReq() {
		console.log('ChatBot, createConversationsPostReq - !this.conversationId=', !this.conversationId);
		if (!this.conversationId) {
			this.initService();
			if (this.storeService.getGlobalAttributes() && this.storeService.getGlobalAttributes().chatBotAuth) {
				this.headers = {
					'Content-Type': 'application/json',
					charset: 'utf-8',
					Authorization: 'Bearer ' + this.storeService.getGlobalAttributes().chatBotAuth,
				};
				const url = this.baseApiUrl;
				this.setErrorTimeout();
				fetch(url, {
					method: 'POST',
					headers: this.headers,
				})
					.then((response) => {
						if (response.ok) {
							this.removeErrorTimeout();
							return response.json();
						} else {
							this.setErrorMsg();
							//console.error('Request failed:', response.status);
						}
					})
					.then((data: IChatbotStartConv) => {
						this.removeErrorTimeout();

						this.isTyping$.next(false);

						this.conversationId = data.conversationId;
						sessionStorage.setItem(this.CHATBOT_CONV_ID, this.conversationId);

						this.sendMessage('HOMEQUOTING_FAQ_Ratespage');
						this.getConversation();
						console.log('Response body:', data);
					})
					.catch((error) => {
						this.removeErrorTimeout();

						this.isTyping$.next(false);

						this.setErrorMsg();
						console.log('Request failed:', error);
					});
			}
		} else {
			this.getConversation();
		}
	}

	getConversation(): Promise<IChatbotGetConvData> {
		// this.createConversationsPostReq();
		const url = `${this.baseApiUrl}/${this.conversationId}/activities`;
		this.setErrorTimeout();

		const postReq = fetch(url, {
			method: 'GET',
			headers: this.headers,
		}).then((response) => {
			if (response.ok) {
				return response.json();
			} else {
				console.error('Request failed:', response.status);
				throw new Error('Response not ok');
			}
		});
		postReq
			.then((data: IChatbotGetConvData) => {
				this.isTyping$.next(false);

				this.updateData(data);
				setTimeout(() => {
					console.log('ChatBot addConvActivity focus', document.getElementById('end-of-conversation-container'));

					document.getElementById('end-of-conversation-container') &&
						document.getElementById('end-of-conversation-container').scrollIntoView({
							behavior: 'smooth',
							block: 'end',
							inline: 'nearest',
						});
				}, 0);
				console.log('Response body:', data);
			})
			.catch((error) => {
				this.isTyping$.next(false);
				this.setErrorMsg();
				console.log('Request failed:', error);
			});
		return postReq;
	}

	setErrorTimeout() {
		this.removeErrorTimeout();
		console.log('set ErrorTimeout');
		this.errorTimeout$ = setTimeout(() => this.setErrorMsg, this.ERROR_TIMEOUT);
	}

	removeErrorTimeout() {
		console.log('remove ErrorTimeout');
		this.errorTimeout$ && clearInterval(this.errorTimeout$);
		this.errorTimeout$ = null;
	}

	updateData(data: IChatbotGetConvData) {
		this.conData = data;
		this.conData$.next(data);
	}

	setErrorMsg() {
		if (this.storeService.getGlobalAttributes() && this.storeService.getGlobalAttributes()['chatbot-exit-ramp']) {
			setTimeout(() => {
				this.removeErrorTimeout();
				const activities = this.conData ? this.conData.activities : null;
				if (activities && activities.length > 0 && activities[activities.length - 1].type === 'error') return;
				const errorMassage =
					(activities && activities.length == 0) || !activities
						? 'Sorry, it looks like we lost connection. One moment while we fix the issue.  If you need immediate assistance, please contact a licensed Progressive agent at the number provided.'
						: "Sorry, I'm not understanding your question. If you still need help, please contact one of our licensed home insurance agents at the number provided.";

				this.addConvActivity(errorMassage, 'error');
			}, 300);
		}
	}

	sendMessage(message: string): Promise<void> {
		this.addconvTyping();
		this.setErrorTimeout();

		console.log('ChatBot, sendMessage - message=', message);
		const url = `${this.baseApiUrl}/${this.conversationId}/activities`;
		const body = {
			type: 'message',
			from: {
				id: '550535748',
				name: 'quoteUser',
			},
			conversation: {},
			text: message,
			suggestedActions: {
				actions: [],
			},
			attachments: [
				{
					name: 'HQX',
					contentType: 'application/vnd.microsoft.card.hero',
					contentUrl: '',
					content: {
						quoteId: this.storeService.getGlobalAttributes() && this.storeService.getGlobalAttributes().externalId,
					},
				},
			],
			channelId: 'directline',
			links: [],
			extenders: {},
			embedded: {},
			validationDetails: {},
			messages: {},
			applicationBuildVersion: '1.0.0.000',
		};

		return fetch(url, {
			method: 'POST',
			headers: this.headers,
			body: JSON.stringify(body),
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				} else {
					console.error('ChatBot, Request failed:', response.status);
					throw new Error('Response not ok');
				}
			})
			.then((data: IChatbotStartConv) => {
				this.isTyping$.next(false);
				this.getConversation();
				console.log('ChatBot, Response body:', data);
			})
			.catch((error) => {
				this.isTyping$.next(false);
				this.setErrorMsg();
				console.log('Request failed:', error);
			});
	}

	showDialog(show: boolean = true) {
		if (show) {
			this.createConversationsPostReq();
		}
		this.storeService.closePopup();
		this.showDialog$.next(show);
	}

	addConvActivity(action: string, type: string = 'message') {
		console.log(action);
		const activity = {
			type: type,
			id: '',
			timestamp: '',
			serviceUrl: '',
			channelId: '',
			from: {
				id: '550535748',
				name: 'quoteUser',
			},
			conversation: undefined,
			text: action,
			suggestedActions: undefined,
			attachments: [
				{
					name: 'HQX',
					contentType: 'application/vnd.microsoft.card.hero',
					contentUrl: '',
					content: {
						quoteId: this.storeService.getGlobalAttributes() && this.storeService.getGlobalAttributes().externalId,
					},
				},
			],
			links: [] as [],
			extenders: undefined,
			embedded: undefined,
			validationDetails: undefined,
			messages: undefined,
			applicationBuildVersion: '',
		};

		setTimeout(() => {
			console.log('ChatBot addConvActivity focus', document.getElementById('end-of-conversation-container'));

			document.getElementById('end-of-conversation-container') &&
				document.getElementById('end-of-conversation-container').scrollIntoView({
					behavior: 'smooth',
					block: 'end',
					inline: 'nearest',
				});
		}, 0);
		if (!this.conData.activities) {
			this.conData.activities = [];
		}
		this.conData.activities.push(activity);
		if (action !== 'typing' && type !== 'error') {
			this.sendMessage(action);
		}
		if (type === 'error') {
			this.conData.activities = this.conData.activities.filter((a) => a.text !== 'typing');
		}
		this.conData$.next(this.conData);
	}

	addconvTyping() {
		this.isTyping$.next(true);
	}
}
